<template>
  <div
    class="form-group-simple digital-signature"
    :class="{
      'form-group-simple--completed': completed
    }"
  >
    <tabs :tabs="tabs" @selected="setActiveTab" />
    <div v-show="activeTab === 'Handmatig'">
      <VueSignaturePad :id="id" ref="signaturePad" class="digital-signature__signature-canvas" :name="name" />
      <div class="row grid-margin grid-justify-content-left digital-signature__actions">
        <div class="col-xs-12 col-sm-6">
          <a class="undoSign" @click="undoSignature">Handtekening opnieuw zetten</a>
        </div>
        <div class="col-xs-12 col-sm-6">
          <v-button lg secondary nowrap class="save-sign" @click.prevent="saveSignature">
            Handtekening opslaan
          </v-button>
        </div>
        <div class="form-group-simple__details" v-if="customErrorMessage">
          <div class="form-group-simple__messages">
            <div class="form-group-simple__error">
              <span> <v-error-icon></v-error-icon> {{ customErrorMessage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="activeTab === 'Upload'" class="pt-2">
      <VInputFileUpload
        :save-image-preview="imagePreview"
        :allowed-extenstions="allowedSignatureExtenstions"
        :extension-error-message="customExtenstionMessage"
        size-error-message="Het geüploade document is te groot. Het document mag niet groter zijn dan 1MB."
        upload-button-message="Handtekening opslaan"
        :max-items="1"
        :custom-Size-Limit="1"
        :registration="true"
        drop-area-secondary-message="max 1MB; alleen pdf en afbeeldingen"
        @upload-success="saveUploadedFiles"
        @save-file="saveUploadedFileName"
      />
    </div>
  </div>
</template>

<script>
import { VueSignaturePad } from 'vue-signature-pad';
import VErrorIcon from 'icons/AlertCircle';
import { useStore } from 'vuex';
import { ref, onMounted, nextTick } from 'vue';
import VInputFileUpload from '@/components/shared/form/simple/InputFileUpload';
export default {
  name: 'VInputDigitalSignature',
  components: {
    VueSignaturePad,
    VInputFileUpload,
    VErrorIcon
  },
  props: {
    name: {
      default: 'signature',
      type: String
    },
    label: {
      default: 'signature',
      type: String
    },
    id: {
      default: '',
      type: String
    },
    desc: {
      default: null,
      type: String
    },
    isRegistration: {
      default: false,
      type: Boolean
    }
  },
  emits: ['save-signature'],
  setup(props, { emit }) {
    const store = useStore();
    const tabs = ref([
      { id: 1, name: 'Handmatig', label: 'Handmatig', current: true },
      { id: 2, name: 'Afbeelding van handtekening invoegen', label: 'Upload', current: false }
    ]);
    const completed = ref(false);
    const activeTab = ref('Handmatig');
    const setActiveTab = (selected) => {
      activeTab.value = selected.label;
      tabs.value.forEach((tab) => (tab.current = tab.name === selected.name));
    };
    const allowedSignatureExtenstions = ref(['pdf', 'jpg', 'png', 'jpeg', 'tiff', 'bmp']);
    const customExtenstionMessage = ref(
      'Het geüploade document heeft niet de juiste extensie. U kunt alleen .pdf, .jpg, .png, .jpeg, .tiff of .bmp documenten uploaden.'
    );
    const imagePreview = ref(true);
    const setSignatureSaved = (value) => store.commit('prescriber/setSignatureSaved', value);
    const setUploadedFileName = (value) => store.commit('prescriberRegistration/setUploadedFileName', value);
    const saveUploadedFiles = (formData) => {
      emit('save-signature', formData, activeTab.value);
    };
    const saveUploadedFileName = (fileName) => {
      setUploadedFileName(fileName);
    };
    onMounted(() => {
      setTimeout(() => {
        const canvas = document.querySelector('.digital-signature__signature-canvas canvas');
        if (!props.isRegistration) {
          canvas.height = canvas.width;
        } else {
          canvas.height = 300;
        }
      }, 0);
    });

    return {
      setSignatureSaved,
      activeTab,
      tabs,
      setActiveTab,
      allowedSignatureExtenstions,
      customExtenstionMessage,
      imagePreview,
      saveUploadedFileName,
      saveUploadedFiles,
      completed
    };
  },
  data() {
    return {
      customErrorMessage: false
    };
  },
  methods: {
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (data) {
        this.customErrorMessage = '';
        this.$emit('save-signature', data, this.activeTab);
      } else {
        this.customErrorMessage = 'Signature is verplicht.';
      }
    },
    // Function to undo the change in the signature pad
    undoSignature() {
      this.customErrorMessage = '';
      this.$refs.signaturePad.undoSignature();
      this.$emit('undoSignature');
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  border: 1px solid $pure-red;
}
.form-group-simple {
  position: relative;
  &__error .alert-circle-icon {
    display: inline-flex;
    width: 16px;
    height: 16px;
    fill: $pure-red;
    vertical-align: bottom;
  }
}
.digital-signature {
  width: 500px;
  .description {
    font-size: 15px;
    font-weight: normal;
  }
  &__signature-canvas {
    min-height: 300px;
    margin-top: 10px;
    border: solid 1px $grayish-darkish;
    background-color: $white;
    background-size: 15px 15px;
    background-image: linear-gradient(to right, $black -3px, transparent 1px),
      linear-gradient(to bottom, $black -3px, transparent 1px);
  }
  &__actions {
    margin-top: 10px;
    .btn {
      background-color: $teal-darkest;
    }
    .undoSign {
      font-size: 16px;
      line-height: 1.5rem;
      color: $teal-darkest;
      cursor: pointer;
      text-decoration: underline;
      margin-top: 0.75rem;
    }
  }
}
</style>
